module.exports = __webpack_public_path__ + "img/message-question.ed543823.svg";